<template>
  <sui-segment :loading="$store.state.device.inProgress" vertical>
    <sui-message error v-if="$store.state.auth.error !== ''">{{$store.state.auth.error}}</sui-message>
    <account-details :user-details="$store.getters.userDetails" :token="$store.getters.userToken" :user-clients="$store.state.client.userClients" />
  </sui-segment>
</template>
<script>
  import AccountDetails from "../components/AccountDetails";
  export default {
    components: {AccountDetails},
    async mounted() {
      await this.$store.dispatch('loadUserDetails')
      await this.$store.dispatch('client/loadUserClients')
    }
  }
</script>

<style scoped>

</style>
